module.exports = __webpack_public_path__ + "static/media/suv-btc.75fbb737.png";